// extracted by mini-css-extract-plugin
export default {"banks":"style_banks__F-stj","banksButton":"style_banksButton__uknOo"};